module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Authors_note"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Author’s note")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There had been little time in the final months of writing "), _c('i', [_vm._v("Jack Davenport: Beaufighter Leader")]), _vm._v(" to read for pleasure, and I had saved up a pile of old favourites and new books for a literary splurge. Near the top was H.E. Bates’s lyrical and moving account of the Battle of Britain, "), _c('i', [_vm._v("A Moment in Time")]), _vm._v(". It was as fresh as on my first reading but this time it provoked a new thought. When an Australian appeared, I wondered if Australian pilots had fought in the Battle or if Bates had exercised inclusive literary licence. I decided to find out.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("I learned that ‘30 or so’ Australians had fought."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/32_Notes#fn1-aut",
      "id": "ft1-aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Thirteen died during the Battle, another five before the end of the war. I spent hours looking at their photographs – young men in uniform with clear eyes gazing at a camera that would forever preserve their images but obscure their characters, personalities, hopes and dreams. I decided to tell their story.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But who to choose? I planned a loose narrative structure and decided to select pilots whose stories best fit into that arc. The first to die. The last. Death – or at least an untimely exit – in each phase of the Battle. A survivor. But I also wanted a broad spread of backgrounds and experiences. State school, private school. Catholic, Protestant. RAAF trained, short service commission, Royal Air Force Volunteer Reserve. Married or affianced and single. The natural pilot. The one who struggled or failed to impress in training but later astounded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Bill Millington, John Crossman, Ken Holland, Dick Glyde, Jack Kennedy, Stuart Walch, Des Sheen and Pat Hughes all met my loose criteria. They were as young as their fictional counterparts: their ages ranged from 20 to 26, with the youngest and eldest coincidentally sharing a birthday. The majority were born in 1917. Those men may have been young, but most possessed a maturity that belied their age and they rank among ‘The Few’. It is a privilege to tell of their part in Britain’s defence.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For the general narrative and framework of the Battle of Britain, I have drawn on the official account of the RAF’s Air Historical Branch, which was first published in 1947 and republished in 2000. Daily casualty numbers differ depending on the source. I have deferred to those compiled by Derek Wood and Derek Dempster in "), _c('i', [_vm._v("The Narrow Margin")]), _vm._v(". The Battle of Britain Historical Society’s website has been a key resource for casualty lists.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For background biographical material, Kenneth G. Wynn’s "), _c('i', [_vm._v("Men of the Battle of Britain: A Biographical Directory of ‘The Few’")]), _vm._v(" has been invaluable, as has the assistance of Geoff Simpson, historical advisor to and trustee of the Battle of Britain Memorial Trust and editor of the forthcoming third edition of Wynn’s biographical directory. Where possible, I have included the given names of the squadron friends, wartime associates and instructors of Australia’s ‘Few’. Unfortunately, squadron records and other sources did not always record given names, and our diarists often included only rank and surname.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("Throughout, I have cited victory tallies. At the time, a ‘destroyed’ had to be verified by someone who had seen the downed aircraft, such as another pilot or a person on the ground like a member of the observer corps or Home Guard. Even so, ")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("there is much debate about overall numbers, because often more than one pilot contributed to the destruction of an enemy aircraft. For squadron claims I have drawn on their operations record books. For individual scores, I have deferred to the forensic postwar work of Christopher Shores and Clive Williams in their "), _c('i', [_vm._v("Aces High")]), _vm._v(" and in the former’s "), _c('i', [_vm._v("Those Other Eagles")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("In the interests of consistency and readability, where appropriate, I have corrected spelling and ‘improved’ punctuation in quoted extracts. For ease of reading, I have not used the 24-hour clock.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("In recent years there has been some softening of how the men of the Battle of Britain are collectively referred to, but ‘The Few’ is more appropriately capitalised within quote marks and I too have adopted this style."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/32_Notes#fn2-aut",
      "id": "ft2-aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Modern aviation literature refers to the German fighter types as the Bf109 and 110, but Allied pilots knew the aircraft as Mess-erschmitts and would call them ‘Mes’. Contemporary sources such as combat reports, operations record books and squadron diaries use the ‘Me’ prefix. In deference to the pilots, I also use it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The RAF was split into functional units called commands. Of these, key to Britain’s defence were Bomber Command, which controlled the bombing force; Coastal Command, which was dedicated to maritime defence and protection of supply lines; and Fighter Command, which was responsible for Britain’s fighter operations. Fighter Command was divided into a number of groups which had operational responsibilities for specific areas of the United Kingdom. 11 Group covered London and the south of England, 12 Group defended central England as well as central and north Wales, and 13 Group covered England’s north and Scotland. 10 Group, which formed on 1 June 1940, became operational on 8 July and assumed responsibility for southwest England and south Wales.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("Measurement conversions are messy, especially in quoted text, and so for ease of reading I have used the imperial form.")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "td",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "42%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "43%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-paraa"
  })]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1a"
  }, [_c('b', [_vm._v("Imperial")])])]), _vm._v(" "), _c('td', {
    staticClass: "td1",
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1a"
  }, [_c('b', [_vm._v("Metric")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-paraa"
  }, [_c('b', [_vm._v("Length")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1a"
  }, [_vm._v("1 inch")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1a"
  }, [_vm._v("2.5 centimetres")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1 foot / 12 inches")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("30.5 centimetres")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1 yard / 3 feet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("91.4 centimetres")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1 mile / 5280 feet")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1.6 kilometres")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Weight")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1 pound / 16 ounces")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("453.6 grams")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1 stone / 14 pounds")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("6.4 kilograms")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  }, [_c('b', [_vm._v("Capacity")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("1 gallon")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para1"
  }, [_vm._v("4.5 litres")])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fbc95dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Authors_note.vue
// module id = 75
// module chunks = 0